import { useEffect } from 'react';

// helpers
import isNamesListSite from 'helpers/isNamesListSite';

const NamesListFacebookPixel = () => {
  useEffect(() => {
    if (isNamesListSite()) {
      // Create and append the script
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '3202802559861259');
        fbq('track', 'PageView');
    `;
      document.body.appendChild(script);

      // Create and append the noscript tag
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src =
        'https://www.facebook.com/tr?id=3202802559861259&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);

      // Cleanup function
      return () => {
        document.body.removeChild(script);
        document.body.removeChild(noscript);
      };
    }
  }, []);

  return null;
};

export default NamesListFacebookPixel;
